module.exports = __webpack_public_path__ + "static/media/recommender1.fec33c80.png";